module.exports = __webpack_public_path__ + "img/Lobby_Video3.3f0c8abd.jpg";